// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CompteFactures_button__1ef4G {\n  margin-right: 16px;\n}\n@media (min-width: 600px) {\n  .CompteFactures_button__1ef4G {\n    margin-right: 24px;\n  }\n}\n", "",{"version":3,"sources":["webpack://src/Components/Compte/CompteFactures.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".button {\n  margin-right: 16px;\n}\n@media (min-width: 600px) {\n  .button {\n    margin-right: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "CompteFactures_button__1ef4G"
};
export default ___CSS_LOADER_EXPORT___;
